import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Select,
  MenuItem,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18nextInstance from '../i18n';
import logo from '../assets/logo.png';

function Navbar() {
  const { t } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const changeLanguage = (event) => {
    const newLang = event.target.value;
    i18nextInstance.changeLanguage(newLang);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navLinks = [
    { key: 'home', path: '/' },
    { key: 'about', path: '/about' },
    { key: 'contact', path: '/contact' },
    { key: 'customerArea', path: '/customer-area' },
  ];

  // 🧱 Drawer (menu mobile)
  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{
        textAlign: 'center',
        background: 'linear-gradient(180deg, #29C6D9, #35E3C8)',
        height: '100%',
        color: 'white',
      }}
    >
      <Box sx={{ py: 3 }}>
        <img src={logo} alt="SPEEDY" style={{ width: 150 }} />
      </Box>
      <List>
        {navLinks.map((item) => (
          <ListItem key={item.key} disablePadding>
            <ListItemButton
              component={Link}
              to={item.path}
              sx={{
                textAlign: 'center',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' },
              }}
            >
              <ListItemText primary={t(`nav.${item.key}`)} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Select
        value={i18nextInstance.language}
        onChange={changeLanguage}
        sx={{
          mt: 2,
          color: 'white',
          '& .MuiSelect-icon': { color: 'white' },
          '& .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
        }}
      >
        <MenuItem value="fr">FR</MenuItem>
        <MenuItem value="en">EN</MenuItem>
      </Select>
    </Box>
  );

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          background: 'linear-gradient(180deg, #29C6D9, #35E3C8)',
          boxShadow: 'none',
          zIndex: 1200,
        }}
      >
        <Toolbar>
          {/* 🟢 Logo */}
          <Box
            component="img"
            src={logo}
            alt="SPEEDY Transport & Logistics"
            sx={{ width: 180, height: 'auto', mr: 2 }}
          />

          {/* 🟡 Menu hamburger (mobile seulement) */}
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { xs: 'flex', md: 'none' }, ml: 'auto' }}
          >
            <MenuIcon />
          </IconButton>

          {/* 🔵 Menu desktop */}
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              flexGrow: 1,
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            {navLinks.map((item) => (
              <Button
                key={item.key}
                color="inherit"
                component={Link}
                to={item.path}
                sx={{
                  fontWeight: 'bold',
                  fontSize: '1.1rem',
                  textTransform: 'none',
                  mx: 1.5,
                  '&:hover': { backgroundColor: 'rgba(255,255,255,0.2)' },
                }}
              >
                {t(`nav.${item.key}`)}
              </Button>
            ))}

            {/* 🌍 Sélecteur de langue */}
            <Select
              value={i18nextInstance.language}
              onChange={changeLanguage}
              sx={{
                ml: 2,
                color: 'white',
                '& .MuiSelect-icon': { color: 'white' },
                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
                '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'white' },
              }}
            >
              <MenuItem value="fr">FR</MenuItem>
              <MenuItem value="en">EN</MenuItem>
            </Select>
          </Box>
        </Toolbar>
      </AppBar>

      {/* 🔹 Drawer (menu mobile) */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { width: 240 },
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
}

export default Navbar;
